import { ArrowForward, EditOutlined } from '@mui/icons-material'
import { Box, Button, Divider, Link, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RiskAggregationEntity } from '@omnea-app/risks/risksFrontendClient'
import { ListRisksResponse } from '../../../../../../../../list/useListRisks'

type Props = {
  viewRisksLink?: string
  aggregationEntity: RiskAggregationEntity
  risksForQuestion?: NonNullable<ListRisksResponse['data']>
  setRiskIdToEdit?: (value: string) => void
  closeTooltip: () => void
}

export const RiskChipTooltipAggregation: FC<Props> = ({
  viewRisksLink,
  aggregationEntity,
  risksForQuestion,
  setRiskIdToEdit,
  closeTooltip,
}) => {
  const { t } = useTranslation('risks')

  return (
    <>
      <Stack>
        <Typography variant="small-regular" color="text.default" sx={{ flex: '0 0 50%' }}>
          {`${t(`chip-tooltip.aggregation.${aggregationEntity}`)}`}
        </Typography>
        <Divider sx={{ paddingTop: '10px', paddingBottom: '8px', width: '100%' }} />
      </Stack>
      <Stack>
        {risksForQuestion && setRiskIdToEdit ? (
          <>
            <Typography
              variant="small-regular"
              color="text.subtle"
              sx={{
                /* FIXME: use a supported typography variant */ fontSize: '0.625rem',
                paddingBottom: '10px',
                flex: '0 0 50%',
              }}
            >
              {`${t('chip-tooltip.aggregation.risks-title')}`}
            </Typography>
            <Stack gap={3}>
              {risksForQuestion.map((risk) => (
                <Box key={risk.id} display="flex" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                  <Typography variant="small-regular">{risk.name}</Typography>
                  <EditOutlined
                    onClick={() => {
                      closeTooltip()
                      setRiskIdToEdit(risk.id)
                    }}
                    fontSize="small"
                    sx={{
                      cursor: 'pointer',
                      color: 'fg.subtle',
                      '&:hover': {
                        color: 'fg.muted',
                        backgroundColor: 'bg.interactive.hover',
                      },
                    }}
                  />
                </Box>
              ))}
            </Stack>
          </>
        ) : viewRisksLink ? (
          <Link href={viewRisksLink}>
            <Button
              sx={{ width: 'auto', alignSelf: 'flex-start', padding: 0, ['&:hover']: { background: 'none' } }}
              color="secondary"
              variant="text"
              size="small"
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Typography color="text.muted">{t('chip-tooltip.aggregation.cta')}</Typography>
                <ArrowForward sx={{ color: 'fg.muted' }} fontSize="small" />
              </Box>
            </Button>
          </Link>
        ) : null}
      </Stack>
    </>
  )
}
